import { PiWarning, PiCopy } from 'react-icons/pi'

/**
 * Token-styled legend shown below the validation grid. Explains the row / cell
 * markers a user will see while reviewing import data.
 *
 * Mirrors the design mockup minus the "Placeholder company" item — ghost /
 * placeholder companies are out of scope for the standalone contacts importer.
 */
export function ValidationLegend() {
  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="flex items-center gap-1.5">
        <PiCopy className="size-3 shrink-0 text-info-strong" />
        <span className="text-xs text-fg-secondary">Duplicate contact</span>
      </div>
      <div className="flex items-center gap-1.5">
        <PiWarning className="size-3 shrink-0 text-error-strong" />
        <span className="text-xs text-fg-secondary">Error — must fix</span>
      </div>
      <div className="flex items-center gap-1.5">
        <PiWarning className="size-3 shrink-0 text-warning-strong" />
        <span className="text-xs text-fg-secondary">Warning — review</span>
      </div>
    </div>
  )
}
